import React from "react";
import { HiXMark, HiExclamationTriangle } from "react-icons/hi2";
import "../styles/Modals.css";

const ErrorModal = ({ message, onClose }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content error-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="close-btn" onClick={onClose}>
          <HiXMark />
        </button>

        <div className="error-header">
          <div className="error-icon">
            <HiExclamationTriangle />
          </div>
          <h2>Feature Unavailable</h2>
        </div>

        <p className="error-message">{message}</p>

        <div className="modal-actions">
          <button className="btn-primary" onClick={onClose}>
            Understood
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
